import { TBidPackageLog, TLinkedDesignPackageSummary } from "../model";

export const DESIGN_PACKAGES_LINKED = "Design Packages Linked";
export const NO_DESIGN_PACKAGES_LINKED = "No Design Packages Linked";

export const formatLinkedDesignPackage = ({
  number,
  name,
  title
}: TLinkedDesignPackageSummary) =>
  [number, name || title].filter(Boolean).join(" - ");

/** One package per line, matching linked materials and linked tasks. */
export const formatLinkedDesignPackagesForExport = (value: unknown): string => {
  if (value == null || value === "") return "";
  const items = Array.isArray(value) ? value : [value];
  return items
    .map((item) => {
      if (typeof item === "string") return item.trim();
      if (!item || typeof item !== "object") return "";
      return formatLinkedDesignPackage(item as TLinkedDesignPackageSummary);
    })
    .filter(Boolean)
    .join("\n");
};

export const getLinkedDesignPackageLabels = (
  row: Pick<TBidPackageLog, "linked_design_packages"> | undefined
): string[] =>
  (row?.linked_design_packages ?? [])
    .map(formatLinkedDesignPackage)
    .filter(Boolean);

/**
 * Sort key for the column. The set filter also sorts its option strings with
 * the column comparator, so this accepts a plain string as well as the label array.
 */
export const toLinkedDesignPackagesSortKey = (value: unknown): string =>
  Array.isArray(value) ? value.join(", ") : ((value as string) ?? "");

/** Set filter value, matching the linked / not linked choice on Linked Materials. */
export const getLinkedDesignPackagesFilterValue = (
  row: Pick<TBidPackageLog, "linked_design_packages"> | undefined
): string =>
  getLinkedDesignPackageLabels(row).length
    ? DESIGN_PACKAGES_LINKED
    : NO_DESIGN_PACKAGES_LINKED;
